module.exports = __webpack_public_path__ + "static/icons/icon-accommodation-4dd450779e6a607003b22d2f97b02147.svg";